export default "__VITE_ASSET__BlL_QGZe__"